'use client';

import type { ReactNode } from 'react';
import { IconButton } from '../../../components/icon-button';
import { Tooltip } from '../../../components/tooltip';

export function CatalogRowIconAction({
  label,
  ariaLabel,
  disabled,
  loading,
  onClick,
  children,
}: {
  label: string;
  ariaLabel?: string;
  disabled: boolean;
  loading?: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <Tooltip title={label} positioning={{ strategy: 'fixed' }}>
      <IconButton
        variant="ghost"
        size="sm"
        aria-label={ariaLabel ?? label}
        disabled={disabled}
        loading={loading}
        onClick={onClick}
        px={2}
      >
        {children}
      </IconButton>
    </Tooltip>
  );
}
